export default __webpack_public_path__ + "static/media/icon_editor_link.85d72025.svg";